import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import api from '../api/axios';

export default function VendorDetails() {
  const { id } = useParams();
  const [vendor, setVendor] = useState(null);

  useEffect(() => {
    const fetchVendor = async () => {
      try {
        const res = await api.get(`/vendors/${id}`);
        setVendor(res.data.data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchVendor();
  }, [id]);

  if (!vendor) return <div style={{ padding: 20 }}>Loading...</div>;

  return (
  <div style={{ padding: 20 }}>
    <h2>{vendor?.displayName || 'No Name'}</h2>

    <p><b>Vendor Code:</b> {vendor?.vendorCode || '-'}</p>
    <p><b>Legal Name:</b> {vendor?.legalName || '-'}</p>
    <p><b>GST:</b> {vendor?.gstNumber || 'N/A'}</p>
    <p><b>Phone:</b> {vendor?.contacts?.[0]?.phone || '—'}</p>
    <p><b>City:</b> {vendor?.address?.city || '-'}</p>
    <p><b>Status:</b> {vendor?.status || '-'}</p>
  </div>
);
}